import { render, staticRenderFns } from "./ViewRecipe.vue?vue&type=template&id=353f7845&"
import script from "./ViewRecipe.vue?vue&type=script&lang=js&"
export * from "./ViewRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports